export const CONNECTOR_OAUTH_CALLBACK_PATH = "/connectors/oauth/callback";
export const CONNECTOR_OAUTH_COMPLETE_PATH = "/api/connectors/oauth/complete";
